export enum OpenMode {
    NEW = 0,
    EDIT = 1,
    COPY = 2
}